// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".furniture-decor[data-v-2c316257]{align-items:center;color:var(--cp-black);display:flex;font-size:1.4rem;line-height:2rem}@media only screen and (min-width:768px){.furniture-decor[data-v-2c316257]{font-size:1.6rem;line-height:2.2rem;min-height:3.2rem}}.furniture-decor svg[data-v-2c316257]{height:2.4rem;margin-right:.8rem;width:2.4rem}@media only screen and (min-width:768px){.furniture-decor span[data-v-2c316257]{position:relative;top:1px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
